import { RootState } from '@redux/types';

export const bookingSelector = (state: RootState) => state.booking.currentBooking;
